/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalConfig, ModalRef } from '@wfm/core';
import { UserNamePipe } from '@app/common/pipes';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DialogType } from '@app/di/integrations/dialog-type';

@Component({
  selector: 'app-co-reader-dialog',
  templateUrl: './co-reader-dialog.component.html',
  styleUrls: ['./co-reader-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UserNamePipe]
})
export class CoReaderDialogComponent implements OnInit {
  radList$: Observable<any>;

  loading: boolean;
  selected: any;

  type: DialogType;
  acc: string;

  types = DialogType;

  constructor(public config: ModalConfig, public modalRef: ModalRef) {}

  ngOnInit(): void {
    this.loading = true;
    this.type = this.config.data.dialogType;
    this.acc = this.config.data.acc || '';
    const dataSource: Observable<any> = this.config.data.dataSource;
    this.radList$ = dataSource?.pipe(
      tap(rads => {
        if (rads && rads[0] && rads[0].preSelected) {
          this.selected = rads[0];
        }
      }),
      tap(_ => (this.loading = false))
    );
  }

  close() {
    this.modalRef.close();
  }

  select() {
    this.modalRef.close(this.selected);
  }
}
